import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Bell, Plus, MessageCircle, MoreHorizontal } from "lucide-react";
import { useI18n } from "../../contexts/I18nContext";
import { useAuth } from "../../contexts/AuthContext";

/**
 * Bottom navigation — mobile only (< md).
 * Hides on /login, /register and OAuth callback.
 */
export default function MobileBottomNav() {
  const { t } = useI18n();
  const { user } = useAuth();
  const loc = useLocation();

  const hidden = ["/login", "/register"].some((p) => loc.pathname === p || loc.pathname.startsWith(`${p}/`));
  if (hidden) return null;
  if (loc.hash?.includes("session_id=")) return null;

  const items = [
    { key: "more",    icon: MoreHorizontal, label: t("bn_more"),    to: "/catalog" },
    { key: "msgs",    icon: MessageCircle,  label: t("bn_messages"), to: user ? "/wallet" : "/login" },
    { key: "add",     icon: Plus,           label: t("bn_add"),     to: user ? "/animals/new" : "/login", primary: true },
    { key: "alerts",  icon: Bell,           label: t("bn_alerts"),  to: user ? "/dashboard" : "/login" },
    { key: "home",    icon: Home,           label: t("bn_home"),    to: "/" },
  ];

  return (
    <nav
      className="fixed md:absolute bottom-0 inset-x-0 z-40 px-3 pb-3 pt-2 safe-bottom mx-auto w-full md:max-w-md"
      data-testid="mobile-bottom-nav"
    >
      <div className="rounded-2xl border border-[#D4AF37]/30 backdrop-blur-xl bg-black/85 px-2 py-1 flex items-center justify-around">
        {items.map((it) => {
          const active = loc.pathname === it.to;
          if (it.primary) {
            return (
              <Link key={it.key} to={it.to} className="-mt-7 flex flex-col items-center gap-0.5" data-testid={`bn-${it.key}`}>
                <span className="h-12 w-12 rounded-full btn-gold flex items-center justify-center shadow-xl shadow-[#D4AF37]/30 ring-2 ring-black">
                  <it.icon className="h-5 w-5 text-black" />
                </span>
                <span className="text-[10px] font-bold text-[#D4AF37]">{it.label}</span>
              </Link>
            );
          }
          return (
            <Link key={it.key} to={it.to} className={`flex flex-col items-center gap-0.5 px-2 py-1.5 rounded-xl transition ${active ? "text-[#D4AF37]" : "text-white/60 hover:text-white/90"}`} data-testid={`bn-${it.key}`}>
              <it.icon className="h-5 w-5" />
              <span className="text-[10px] font-medium">{it.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
